import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import AuthService from "../services/auth.service";
import "./styles.component.css";
import { Routes, Route, Link } from "react-router-dom";


import { withRouter } from '../common/with-router';

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
Este campo es requerido      </div>
    );
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "",
      password: "",
      loading: false,
      message: "",

      redirect: null,
      userReady: false,
      currentUser: null,
      content:null

    };
  }





  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
     
      AuthService.login(this.state.username, this.state.password).then(
        (result) => {
    
if (result)  { 
    
          this.props.router.navigate("/inicio");
     window.location.reload();
    
      }else{

        this.setState({
          message: "Hay un error en los datos ingresados. ¿Estas seguro de estar Registrado?, Intenta mas tarde.",
          loading: false
        });


      }
      
      },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage
          });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return (
      <div className="hero">
  <header>
    <nav className="navbar">
      <div className="navbar__brand">
      <Link to={"/"} >

        <img src="../img/logo_escuela_aye_sd.png" alt="logo" className="brand__logo" />      </Link >

      </div>
      <div className="navbar__nav__items">
        <div className="nav__item">
      
    
        </div>

      </div>
    </nav>
  </header>
        
      <div className="hero__bg__image__container">
        <img src="https://firebasestorage.googleapis.com/v0/b/arteyefectosfilms.appspot.com/o/imgweb2023%2Ffondoweb.png?alt=media&token=220014d9-8eb4-414d-9080-ecc38671d18e" alt="fondo" className="hero__bg__image" />
      </div>
      
      <div className="hero__bg__overlay" />
      <div className="hero__card2 container">
       
      
        <div className="card card-container">
        <h3>Ingresar Usuario</h3>

        <img
            src="../img/cinema.png"
            alt="profile-img"
            className=""
          />
          
          <Form
            onSubmit={this.handleLogin}
            ref={c => {
              this.form = c;
            }}
          >
            <div className="form-group">
              <label htmlFor="username">Correo Electrónico</label>
              <Input
                type="text"
                className="form-control"
                name="username"
                value={this.state.username}
                onChange={this.onChangeUsername}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <Input
                type="password"
                className="form-control"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <button
                className="btn btn-primary btn-block"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Ingresar</span>
              </button>
            </div>

            {this.state.message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {this.state.message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
            <Link to={"/register"} className="nav-link container">
                  ¿Aún no te has Registrado?

                  <botton className="btn btn-primary btn-block"> <i className="fa fa-address-card" aria-hidden="true" />Ir al Registro</botton>

                </Link>
          </Form>
        </div>
      


      </div>
    </div>
    );
  }
}

export default withRouter(Login);